import deDE from 'src/i18n/de-DE';
import enUS from 'src/i18n/en-US';

export default {
	'de-DE': deDE,
	'en-US': enUS,
};
